// @flow
import { CRISIS_ALERT } from 'Client/cms/toolkit/constants';
import { CrisisAlertLine } from 'Components/lines/crisis-alert-line/CrisisAlertLine';

export const crisisAlertDescriptor = {
  name: CRISIS_ALERT,
  component: CrisisAlertLine,
};
